// extracted by mini-css-extract-plugin
module.exports = {"whty8xo":"whty8xo"};